export const environment = {
  production: false,
  apiUrl: "https://server.dev.bdomobile.com/",
  keycloakUrl: "https://keycloak-dev.mobiletract.com",
  realm: "bdo-dev",
  tpayScript: "https://secure.tpay.com/groups-696041.js",
  clientId: "ekowitryna_admin_panel",
  googleTagManagerId: 'GTM-T43SC6BD',
  googleTagManagerPreview: 'env-3',
  googleTagManagerAuth: 'nwRCCNlB1-SPt0eiDeFIOw',
  enableDebugControls: true,
  signozUrl: "https://otlp.monitoring.mobiletract.com",
  signozEnv: "dev",
  signozServiceName: "ekowitryna-admin-panel_web",
  platformWebUrl: "https://platforma.dev.bdomobile.com",
  allowedReturnUrlOrigins: [
    'https://platforma.dev.bdomobile.com',
    'https://panel.dev.bdomobile.com',
    'https://kobize.ekowitryna.pl',
    'https://esg.dev.bdomobile.com',
    'http://localhost:4200',
  ],
};
